<template>
  <v-container>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-cloud-upload
      </v-icon> Document Uploads
    </h2>
    <br>
    <v-card
      color="#CFD8DC"
    >
      <v-btn
        color="#37474F"
        class="upload-btn"
        outlined
        small
        @click="openUploadForm()"
      >
        <v-icon left>
          mdi-cloud-upload
        </v-icon>
        Document
      </v-btn>
      <v-expansion-panels
        elevation
        color="red"
        hover
        popout
        accordion
        light
      >
        <v-expansion-panel
          v-for="(item,i) in UploadedDocs"
          :key="i"
        >
          <v-expansion-panel-header>
            <span class="my-p-style">
              <span class="doc-style">Document {{ i + 1 }}:- {{ item.document_type.name }}</span> <br>
              Status: <font :color="getColor(item.is_active)"> {{ item.is_active | statusUpdate }}</font><br>
              Expires In: <font
                v-if="item.is_active === true && item.expires_in !== undefined"
                class="doc-style"
              > {{ item.expires_in }} Days </font> <font
                v-if="item.is_active === true && item.expires_in === undefined"
                class="doc-style"
              > {{ item.expiry_date | convertToLocal }}</font>
              <font
                v-if="item.is_active === false"
                class="doc-style"
              > N/A</font>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <br>
            <p class="my-p-style">
              Description:
              <font class="my-description-style">
                {{ item.document_type.description }}
              </font>
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="py-3" />
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <upload-document
      v-if="showUploadForm"
      :form-sub-title="formSubTitle"
      @closed="showUploadForm = false"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import UploadDocuments from '../process/Checkin/UploadDocument.vue';
  import moment from 'moment';

  export default {
    name: 'UserUploadedDocs',
    components: {
      'centre-spinner': spinner,
      'upload-document': UploadDocuments,
    },
    filters: {
      statusUpdate (val) {
        if (val === true) {
          return 'Active*';
        }
        return 'Expired';
      },
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY');
      },
    },
    data () {
      return {
        loading: false,
        showUploadForm: false,
        formSubTitle: '',
      };
    },
    computed: {
      UploadedDocs () {
        return this.$store.getters['swiftuser/getUploadedDocs'];
      },
    },
    async mounted () {
     await this.getUploadedDocsList();
    },
    methods: {
      async getUploadedDocsList () {
        this.loading = true;
        await this.$store.dispatch('swiftuser/fetchUploadedDocs');
        this.loading = false;
      },
      getColor (val) {
        if (val === true) {
            return '#2E7D32';
        }
        return '#C62828';
      },
      openUploadForm () {
        this.formSubTitle = 'Please upload your expired documents here.';
        this.showUploadForm = true;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.doc-style {
  color: #37474F;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
.my-description-style {
  font-size: 14px;
  color:#FF3700 !important;
  font-family: 'Times New Roman', Times, serif;
}
.v-expansion-panels {
  z-index: 0;
}
.my-p-style {
    font-size: 14px;
    font-weight: bold;
    color: #546E7A;
    font-family: 'Times New Roman', Times, serif;
    text-transform: capitalize;
    line-height: 1.5;
}
.upload-btn {
  float: right;
  margin-right: 18px;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
